import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Box, Flex, Heading, Text } from 'rebass/styled-components'

import { Price } from './styles'

const ComplementsList = ({ complements, currency }) => {
  if (!complements || complements.length === 0) return null

  return (
    <Box sx={{ mb: 4, display: 'grid' }}>
      <Heading as="h2" variant="accessoriesTitle" sx={{ mb: 1 }}>
        <FormattedMessage
          id="product.complements"
          defaultMessage="Complements"
        />
      </Heading>

      <Text sx={{ mb: 2 }}>Can be added in the order</Text>

      <Flex sx={{ flexDirection: 'column', gap: 2 }}>
        {complements.map((complement) => (
          <Flex
            key={complement.id}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 0,
              padding: '0.75rem',
              bgColor: 'primary',
              borderRadius: 2,
              textDecoration: 'none',
            }}
            style={{
              backgroundColor: '#f7f4e4',
              border: '1px solid #eae2b8',
            }}
          >
            <Box sx={{ display: 'grid', gap: 1 }}>
              <Text sx={{ m: 0, fontSize: 1 }}>{complement.label}</Text>
              <Price style={{ fontSize: '1rem', lineHeight: '1' }}>
                <FormattedNumber
                  style="currency"
                  value={complement.price}
                  currency={currency}
                />
              </Price>
            </Box>

            <Link
              to={`/product/${complement.slug}`}
              sx={{ textDecoration: 'none' }}
            >
              <FormattedMessage
                id="product.complements.view"
                defaultMessage="View"
              />
            </Link>
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}

ComplementsList.propTypes = {
  complements: PropTypes.arrayOf(PropTypes.object),
  currency: PropTypes.string,
}

export default ComplementsList
